window.ENV ={
    "RECAPTCHA_SITE": "6LdV9PYfAAAAALZQKOa84KQkK2KTGpiTSUOVrIqQ",
    "USERNAME_PREFIX": "PEG-",
    "ARN_WIDGET_URL": "https://arn.upraise.io/rest/arn/latest/widget/widget-init?widgetId=f491a40f-c496-4c2c-a1a0-2dad38f04c7d&clientKey=jira:2483855&userId="
}
